export default "__VITE_ASSET__gd5CL$ui__"